import NoData from './no-data';
import NoResult from './no-result';
import NotFound from './not-found';
import Refresh from './refresh';

export default {NoData, NoResult, NotFound, Refresh};
